import { API_CONSTANTS, getApiCall, postApiCall } from "../../config/api-constants";

export const GLOBAL_LIST_ENABLE = "GLOBAL_LIST_ENABLE";
export const GLOBAL_LIST_TEMPLATES = "GLOBAL_LIST_TEMPLATES";
export const GLOBAL_LIST = "GLOBAL_LIST";
export const GET_GLOBAL_LIST = "GET_GLOBAL_LIST";
export const ADD_GLOBAL_LIST = "ADD_GLOBAL_LIST";
export const EDIT_GLOBAL_LIST = "EDIT_GLOBAL_LIST";
export const DELETE_GLOBAL_LIST = "DELETE_GLOBAL_LIST";

export const getGlobalListTemplates = (value) => {
    return { type: GLOBAL_LIST_TEMPLATES, payload: value };
};

export const globalListEnable = (value) => {
    return { type: GLOBAL_LIST_ENABLE, payload: value };
}

export const globalListTag = (value) => {
    return { type: GLOBAL_LIST, payload: value };
}

export const getGlobalList = (currentPage, currentRowsPerPage, searchQuery, tags, sortOrder, sortField) => {
    return async (dispatch) => {
        const payload = {
            page: currentPage + 1,
            rows_per_page: currentRowsPerPage,
            ...(searchQuery && { search: searchQuery }),
            filter_tags: tags,
            ...(sortField && { sort_field: sortField }),
            ...(sortOrder && { sort_direction: sortOrder }),
        };
        try {
            const response = await postApiCall(API_CONSTANTS.GET_GLOBAL_LISTS, payload);
            if (response?.data?.success) {
                return dispatch({ type: GET_GLOBAL_LIST, payload: response?.data?.data || [] });
            } else console.error("Failed to load data from server");
        } catch (error) {
            console.error(error);
        }
    };
}

export const addGlobalList = (payload) => {
    return async (dispatch) => {
        try {
            const response = await postApiCall(API_CONSTANTS.ADD_GLOBAL_LIST, payload);
            if (response?.data?.success) {
                return dispatch({ type: ADD_GLOBAL_LIST, payload: response?.data });
            } else console.error("Failed to load data from server");
        } catch (error) {
            console?.error(error);
        }
    };
}

export const editGlobalList = (payload) => {
    return async (dispatch) => {
        try {
            const response = await postApiCall(API_CONSTANTS.EDIT_GLOBAL_LIST, payload);
            if (response?.data?.success) {
                return dispatch({ type: EDIT_GLOBAL_LIST, payload: response?.data?.data });
            } else console.error("Failed to load data from server");
        } catch (error) {
            console.error(error);
        }
    };
}

export const deleteGlobalList = (payload) => {
    return async (dispatch) => {
        try {
            const response = await postApiCall(API_CONSTANTS.DELETE_GLOBAL_LIST, payload);
            if (response?.data?.success) {
                return dispatch({ type: DELETE_GLOBAL_LIST, payload: response?.data?.success });
            } else console.error("Failed to load data from server");
        } catch (error) {
            console.error(error);
        }
    };
}

export const getGlobalListById = (payload) => {
    return async (dispatch) => {
        try {
            const response = await getApiCall(API_CONSTANTS.GET_GLOBAL_LIST_BY_ID + "/" + payload);
            if (response?.data?.success) {
                return response?.data?.data;
            } else console.error("Failed to load data from server");
        } catch (error) {
            console.error(error);
        }
    };
}